<template>
  <div class="card" ref="card">
    <div class="card-border"></div>
    <div class="card-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "Card",
  mounted() {
    const card = this.$refs.card;
    const border = card.querySelector(".card-border");

    card.addEventListener("mousemove", (e) => {
      const rect = card.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      // Set the gradient position based on the mouse position
      const gradientX = (x / rect.width) * 100;
      const gradientY = (y / rect.height) * 100;

      // Calculate gradient size based on card dimensions
      const gradientSize = Math.min(rect.width, rect.height) * 3;

      border.style.background = `
        radial-gradient(
          ${gradientSize}px circle at ${gradientX}% ${gradientY}%, 
          rgba(255, 102, 102, 0.4),
          rgba(255, 160, 104, 0.4),
          transparent 40%
        )
      `;
      border.style.opacity = "1";
    });

    card.addEventListener("mouseleave", () => {
      border.style.opacity = "0";
    });
  },
};
</script>

<style scoped>
.card {
  position: relative;
  border-radius: 24px;
  overflow: hidden;
  padding: 1px;
  background: transparent;
}

.card-border {
  position: absolute;
  inset: 0;
  border-radius: 24px;
  transition: all 0.3s ease;
  opacity: 0;
  backdrop-filter: blur(10px);
}

.card-content {
  position: relative;
  z-index: 1;
  background: var(--card-bg, rgba(26, 26, 26, 0.8));
  border-radius: 23px;
  padding: clamp(1rem, 5vw, 2rem);
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

@media (prefers-color-scheme: dark) {
  .card-content {
    --card-bg: rgba(26, 26, 26, 0.8);
  }
}

@media (max-width: 768px) {
  .card {
    border-radius: 20px;
    aspect-ratio: 3/4;
  }

  .card-border {
    border-radius: 20px;
  }

  .card-content {
    border-radius: 19px;
  }
}
</style>
